import { render, staticRenderFns } from "./ReportQuestionAnsweredToday.vue?vue&type=template&id=34db4e1e&"
import script from "./ReportQuestionAnsweredToday.vue?vue&type=script&lang=ts&"
export * from "./ReportQuestionAnsweredToday.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports